import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./archive.css";

const Wms = () => {
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  // ===============================
  // Carica lista WMS (PUBBLICA)
  // ===============================
  useEffect(() => {
    fetchFiles();
  }, []);

  const fetchFiles = async () => {
    try {
      const res = await axios.get("https://hat.sofhare.com/wms/"); // endpoint pubblico
      setFiles(res.data);
    } catch (err) {
      console.error("Errore caricamento WMS", err);
      toast.error("Impossibile caricare i layer WMS");
    }
  };

  // ===============================
  // Copia link negli appunti
  // ===============================
  const handleCopyLink = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link WMS copiato negli appunti!", { autoClose: 1500 });
    } catch (err) {
      console.error("Errore copia link", err);
      toast.error("Impossibile copiare il link");
    }
  };

  return (
    <div className="main-wrapper">
      <ToastContainer />
      <div className="tools-wrapperS1-arch">
        <h1 className="archivio-title">Servizi Tile layer</h1>
        <p>Copia il link Tile e usalo in QGIS o altre piattaforme.</p>

        <table className="files-table">
          <thead>
            <tr>
              <th>Layer</th>
              <th>Tile layer</th>
              <th>Azione</th>
            </tr>
          </thead>

          <tbody>
            {files.length === 0 ? (
              <tr>
                <td colSpan={3} style={{ textAlign: "center" }}>
                  Nessun layer disponibile
                </td>
              </tr>
            ) : (
              files.map((f) => (
                <tr key={f.name}>
                  <td>{f.name}</td>
                  <td className="wms-url">{f.tile_url}</td>
                  <td>
                    <button onClick={() => handleCopyLink(f.tile_url)}>
                      Copia link
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Wms;
